import React from "react";
import ReactCountryDropdown from "react-country-dropdown";
import { useDispatch } from "react-redux";
import {
  setCountryFrom,
  setCountryTo,
  setCurrencyFrom,
  setCurrencyTo,
} from "../store/slices/formSlice";

const Select = ({
  options,
  value,
  onChange,
  label,
  name,
  placeholder,
  containerClass,
  classes,
  isCountrySelector,
  isDisabled,
  color,
  showIcon,
  defaultValue,
  formData,
  handleChange,
}) => {
  const dispatch = useDispatch();

  // Handle country selection change
  const handleCountrySelect = (country) => {
    if (name === "countryFrom") {
      dispatch(setCountryFrom(country)); // Dispatch to update the 'countryFrom' state in Redux
    } else if (name === "countryTo") {
      dispatch(setCountryTo(country)); // Dispatch to update the 'countryTo' state in Redux
    }
    if (onChange) onChange(country); // Trigger parent onChange if provided
  };

  // Handle normal dropdown change
  const handleDropdownChange = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const { value } = e.target;
    if (onChange) {
      onChange(value); // Trigger parent onChange if provided
    }
    if (handleChange) {
      handleChange(e); // If you want to trigger handleChange in parent as well
    }

    // Dispatch updates for currency or other fields if needed
    if (name === "currencyFrom") {
      dispatch(setCurrencyFrom(value)); // Dispatch to update 'currencyFrom' state
    } else if (name === "currencyTo") {
      dispatch(setCurrencyTo(value)); // Dispatch to update 'currencyTo' state
    }
  };

  return (
    <div className={`${containerClass}`}>
      {label && (
        <label className="block font-medium text-gray-500 my-1 lg:ml-0 text-sm sm:text-base md:text-lg lg:text-xl">
          {label}
        </label>
      )}
      <div>
        {isCountrySelector ? (
          <div className={`sm:mx-0 flex items-center justify-around rounded-lg lg:rounded-xl  ${isDisabled ? "pointer-events-none opacity-50" : ""}`}>
            <ReactCountryDropdown
              defaultCountry={defaultValue}
              onSelect={handleCountrySelect} // Call our handleCountrySelect function
              className="!bg-white "
              style={{ backgroundColor: "white !important" }}
              disabled={isDisabled}
            />
          </div>
        ) : (
          <div className={`flex items-center px-1 justify-center ${classes}`}>
            <select
              disabled={isDisabled}
              name={name}
              value={value}
              onChange={handleDropdownChange} // Update onChange to use our custom handler
              className={`border-none appearance-none ring-0 focus:outline-none ${color}`}
            >
              {placeholder && <option value="">{placeholder}</option>}
              {options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            {showIcon && (
              <svg xmlns="http://www.w3.org/2000/svg" width="10.033" height="5">
                <path d="M5.016 0 0 .003 2.506 2.5 5.016 5l2.509-2.5L10.033.003 5.016 0z" />
              </svg>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Select;